// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Slywr","disabled":"FileBtn_disabled__1u5oF","warn":"FileBtn_warn__259HP","fade":"FileBtn_fade__3Guxi"};